import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';

const mutationUpdateUserPassword = (onSuccess, onError) => {
    return {
        mutationFn: ({ oldPassword, newPassword }) => {
            return client.post(USERS.UPDATE_PASSWORD.url, { oldPassword, newPassword });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateUserPassword;